<button (click)="openCreate()" class="btn btn-primary-outline add-button mb-3">Add</button>

<h6>If not set, default maximum working hours is 48 hr p/w</h6>

@if (tableData().length > 0) {
  <app-sortable-table [headers]="headers" (sort)="onSort($event)" class="table-striped">
    @for (item of tableData() | listSort: tableSortEvent(); track item.startDate) {
      <tr>
        <td>{{ item.hours }} hr p/w</td>
        <td>{{ item.startDate | dateParse | dateFormat: 'ddd, D MMM YYYY' }}</td>
        <td>+ {{ item.hours - contractHours() }} hr p/w</td>
        @if (canEditAtDate(item.startDate)) {
          <td>
            <i (click)="openUpdate(item)" class="fa fa-xs fa-pen pointer me-1"></i>
            <i (click)="openDelete(item.startDate)" class="fa fa-xs fa-trash pointer"></i>
          </td>
        } @else {
        <td></td>
      }
      </tr>
    }
  </app-sortable-table>
}